import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

const Sidebar = ({ relatedPosts, popularPosts }) => {
  return (
    <>
      <div></div>
      <div className="side-fixed">
        <div className="side-card">
          <div className="side-title">人気記事</div>
          <div className="side-content">
            {popularPosts.map(post => (
              <div
                key={`side-${post.fields.slug}`}
                className="w-full mt-6 duration-200 hover:text-blue-500"
              >
                <Link className="side-post" to={post.fields.slug}>
                  <div className="duration-200 hover:opacity-80 side-thumbnail">
                    <GatsbyImage
                      image={
                        post.frontmatter.thumbnail?.childImageSharp
                          .gatsbyImageData
                      }
                      alt={post.frontmatter.title}
                    />
                  </div>
                  <p className="font-bold side-post-title">
                    {post.frontmatter.title}
                  </p>
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div className="side-card">
          <div className="side-title">関連記事</div>
          <div className="side-content">
            {relatedPosts.map(post => (
              <div
                key={`side-${post.fields.slug}`}
                className="w-full mt-6 duration-200 hover:text-blue-500"
              >
                <Link className="side-post" to={post.fields.slug}>
                  <div className="duration-200 hover:opacity-80 side-thumbnail">
                    <GatsbyImage
                      image={
                        post.frontmatter.thumbnail?.childImageSharp
                          .gatsbyImageData
                      }
                      alt={post.frontmatter.title}
                    />
                  </div>
                  <p className="font-bold side-post-title">
                    {post.frontmatter.title}
                  </p>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Sidebar
